/* ============================================================================
   Collection-card Add to Cart. Issue #1612.

   Delegated on document, because every pill click and sidebar filter
   replaces .collection-matrix innerHTML wholesale
   (sections/byrna-all-collection.liquid ~2864-2889). Per-form binds go dead
   after the first filter interaction.

   Deliberately does NOT reuse the .ajax-submit path at
   assets/z__jsAjaxCart.js:30. That handler calls .includes() on
   $addToCartForm.parent().attr('data-template-name') at lines 36 and 39
   with no null guard; collection-grid forms have no such attribute, so it
   throws a TypeError before reaching the else fallback at line 43.

   Also deliberately does NOT inherit z__jsAjaxCart.js:178, a synchronous
   async:false XHR against /cart on the main thread after every add.
   showDrawer() and updateView() are called directly instead.

   #1570 hardening carried over: re-entrancy guard, hardcoded quantity 1,
   res.ok check, .catch button recovery.
   ============================================================================ */
(function () {
  'use strict';

  var ADDING_MS = 900;

  function ga4(action, root, extras) {
    if (!window.ByrnaGA4 || !window.ByrnaGA4.feature) return;
    var issue = root ? root.getAttribute('data-bca-issue') : '';
    window.ByrnaGA4.feature(action, 'collection_card_atc', issue, extras || {});
  }

  function ga4AddToCart(btn) {
    if (!window.ByrnaGA4 || !window.ByrnaGA4.addToCart) return;
    var value = parseFloat(btn.getAttribute('data-bca-price'));
    if (isNaN(value)) value = 0;
    window.ByrnaGA4.addToCart(
      btn.getAttribute('data-bca-currency') || 'USD',
      value,
      [{
        item_id: btn.getAttribute('data-bca-product-id'),
        item_name: btn.getAttribute('data-bca-product-title'),
        item_variant: btn.getAttribute('data-bca-variant-id'),
        price: value,
        quantity: 1,
        item_list_id: 'collection_card'
      }]
    );
  }

  function setLabel(btn, text) {
    var el = btn.querySelector('.bca__label');
    if (el) el.textContent = text;
  }

  function release(btn, original) {
    btn.removeAttribute('aria-busy');
    setLabel(btn, original);
  }

  function cartAddUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (root || '/') + 'cart/add.js';
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || typeof target.closest !== 'function') return;

    var btn = target.closest('[data-bca-add]');
    if (!btn) return;

    e.preventDefault();

    /* Re-entrancy guard — a second click while the first is in flight would
       add the item twice. */
    if (btn.getAttribute('aria-busy') === 'true') return;

    var variantId = btn.getAttribute('data-bca-variant-id');
    if (!variantId) return;

    var root = btn.closest('[data-bca]');
    var labelEl = btn.querySelector('.bca__label');
    var original = labelEl ? labelEl.textContent : 'Add to cart';

    btn.setAttribute('aria-busy', 'true');
    setLabel(btn, 'Adding\u2026');

    ga4('click', root, {
      surface: 'collection_card',
      item_id: btn.getAttribute('data-bca-product-id')
    });

    fetch(cartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }]
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/add.js ' + res.status);
        return res.json();
      })
      .then(function () {
        ga4AddToCart(btn);

        var ajaxCart = window.Shopify && window.Shopify.theme && window.Shopify.theme.jsAjaxCart;
        if (ajaxCart) {
          if (typeof ajaxCart.showDrawer === 'function') ajaxCart.showDrawer();
          if (typeof ajaxCart.updateView === 'function') ajaxCart.updateView();
        }

        window.setTimeout(function () { release(btn, original); }, ADDING_MS);
      })
      .catch(function (err) {
        ga4('error', root, {
          surface: 'collection_card',
          item_id: btn.getAttribute('data-bca-product-id'),
          reason_detail: String((err && err.message) || err)
        });
        setLabel(btn, 'Try again');
        window.setTimeout(function () { release(btn, original); }, ADDING_MS * 2);
      });
  });
})();
